/**
 * 运营管理 相关菜单配置
 *
 */

// import Layout from "../components/layout";
import { lazyLoad } from "@/utils/lazyLoad";
const operationsRoute = [
  {
    // component: Layout,
    component: lazyLoad,
    path: "/operations-management",
    name: "operations",
    meta: {
      title: "运营管理",
      icon: "icon-operations",
      code: "operating",
    },
    children: [
      {
        path: "/operations/banner/list",
        name: "BannerManagement",
        component: () => import("../pages/operations/banner/index.vue"),
        meta: {
          title: "广告管理",
          icon: "banner",
          keepAlive: false,
          code: "dm:banner",
        },
      },
      {
        path: "/operations/hospital/list",
        name: "HospitalManage",
        component: () => import("../pages/operations/hospitalManage/index.vue"),
        meta: {
          title: "医院管理",
          icon: "banner",
          keepAlive: true,
        },
      },
      {
        path: "/operations/channelManage/list",
        name: "channelManage",
        component: () => import("../pages/operations/channelManage/index.vue"),
        meta: {
          title: "渠道管理",
          icon: "banner",
          keepAlive: true,
          code: "channel",
        },
      },
      {
        path: "/operations/doctor/list",
        name: "DoctorManage",
        component: () =>
          import("../pages/operations/doctorManage/doctorList/index.vue"),
        meta: {
          title: "医生管理",
          icon: "banner",
          keepAlive: true,
          code: "h5DmUser",
        },
      },
      {
        path: "/operations/doctor/whitelist",
        name: "DoctorWhitelist",
        component: () =>
          import("../pages/operations/doctorWhitelist/index.vue"),
        meta: {
          title: "医生白名单",
          icon: "banner",
          keepAlive: true,
          code: "representative",
        },
      },
      {
        path: "/operations/representative/list",
        name: "RepresentativeManage",
        component: () =>
          import("../pages/operations/representativeManage/index.vue"),
        meta: {
          title: "代表管理",
          icon: "banner",
          keepAlive: true,
          code: "representative",
        },
      },
      {
        path: "/operations/representative/whitelist",
        name: "RepresentativeWhitelist",
        component: () =>
          import("../pages/operations/representativeWhitelist/index.vue"),
        meta: {
          title: "代表白名单",
          icon: "banner",
          keepAlive: true,
          code: "representative",
        },
      },
      {
        path: "/operations/patient/list",
        name: "PatientList",
        component: () => import("../pages/operations/patientManage/index.vue"),
        meta: {
          title: "患者管理",
          keepAlive: true,
        },
      },
      {
        path: "/operations/patientList",
        name: "PatientCheckList",
        component: () => import("../pages/operations/patientList/index.vue"),
        meta: {
          title: "患者列表",
          keepAlive: true,
        },
      },
      {
        path: "/operations/scanRecord",
        name: "scanRecord",
        component: () => import("../pages/operations/scanRecord/index.vue"),
        meta: {
          title: "扫码记录",
          keepAlive: true,
        },
      },
      {
        path: "/operations/bindList",
        name: "BindList",
        component: () => import("../pages/operations/bindManage/index.vue"),
        meta: {
          title: "绑定关系",
          keepAlive: true,
        },
      },
      {
        path: "/operations/audit/list",
        name: "AuditList",
        component: () => import("../pages/operations/auditManage/index.vue"),
        meta: {
          title: "审核列表",
          keepAlive: true,
        },
      },
      {
        path: "/operations/audit/check",
        name: "AuditCheck",
        hidden: true,
        component: () => import("../pages/operations/auditManage/check.vue"),
        meta: {
          title: "审核",
          relatedPermission: "审核列表",
        },
      },
      {
        path: "/operations/expert/list",
        name: "ExpertManage",
        component: () =>
          import("../pages/operations/expertManage/expertList/index.vue"),
        meta: {
          title: "讲师管理",
          icon: "banner",
          keepAlive: true,
          code: "specialist",
        },
      },
      {
        path: "/operations/label/list",
        name: "LabelManagement",
        component: () => import("../pages/operations/label/index.vue"),
        meta: {
          title: "标签管理",
          icon: "banner",
          keepAlive: false,
          code: "label",
        },
      },
      {
        path: "/operations/administrative/list",
        name: "AdministrativeManagement",
        component: () => import("../pages/operations/administrative/index.vue"),
        meta: {
          title: "科室管理",
          keepAlive: false,
          code: "department",
        },
      },
      {
        path: "/operations/title/list",
        name: "TitleManagement",
        component: () => import("../pages/operations/title/index.vue"),
        meta: {
          title: "职称管理",
          keepAlive: false,
          code: "professionalTitle",
        },
      },
      {
        path: "/operations/sensitive/list",
        name: "SensitiveWords",
        component: () => import("../pages/operations/sensitiveWords/index.vue"),
        meta: {
          title: "敏感词汇",
          keepAlive: true,
          code: "filterWord",
        },
      },
      {
        path: "/operations/patientApproval/list",
        name: "PatientApproval",
        component: () =>
          import("../pages/operations/patientApproval/index.vue"),
        meta: {
          title: "材料审核",
          keepAlive: true,
          code: "PatientApproval",
        },
      },
      {
        path: "/operations/label/userLabel",
        name: "userLabel",
        component: () => import("../pages/operations/label/userLabel.vue"),
        meta: {
          title: "用户标签",
          icon: "banner",
          keepAlive: false,
          code: "labelPlus",
        },
      },
    ],
  },
];
export default operationsRoute;
